if (!customElements.get("el-faq-accordion")) {
  class ElFaqAccordion extends HTMLElement {
    constructor() {
      super();

      this.items = [];
      this.resizeObserver = null;

      this.handleButtonClick = this.handleButtonClick.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.items = Array.from(
        this.querySelectorAll("[data-el-faq-item]"),
      );

      this.items.forEach((item) => {
        const button = item.querySelector("[data-el-faq-button]");
        const panel = item.querySelector("[data-el-faq-panel]");

        if (!button || !panel) return;

        button.addEventListener("click", this.handleButtonClick);

        if (item.classList.contains("is-open")) {
          panel.style.height = `${panel.scrollHeight}px`;
          button.setAttribute("aria-expanded", "true");
        } else {
          panel.style.height = "0px";
          button.setAttribute("aria-expanded", "false");
        }
      });

      this.setupResizeObserver();
      window.addEventListener("resize", this.handleResize);
    }

    disconnectedCallback() {
      this.items.forEach((item) => {
        const button = item.querySelector("[data-el-faq-button]");

        if (button) {
          button.removeEventListener("click", this.handleButtonClick);
        }
      });

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }

      window.removeEventListener("resize", this.handleResize);

      this.items = [];
    }

    handleButtonClick(event) {
      const button = event.currentTarget;
      const item = button.closest("[data-el-faq-item]");

      if (!item) return;

      const isOpen = item.classList.contains("is-open");

      if (this.hasAttribute("close-others") && !isOpen) {
        this.items.forEach((otherItem) => {
          if (otherItem !== item) {
            this.closeItem(otherItem);
          }
        });
      }

      if (isOpen) {
        this.closeItem(item);
      } else {
        this.openItem(item);
      }
    }

    openItem(item) {
      const button = item.querySelector("[data-el-faq-button]");
      const panel = item.querySelector("[data-el-faq-panel]");

      if (!button || !panel) return;

      item.classList.add("is-open");
      button.setAttribute("aria-expanded", "true");

      panel.style.height = "0px";

      requestAnimationFrame(() => {
        panel.style.height = `${panel.scrollHeight}px`;
      });
    }

    closeItem(item) {
      const button = item.querySelector("[data-el-faq-button]");
      const panel = item.querySelector("[data-el-faq-panel]");

      if (!button || !panel || !item.classList.contains("is-open")) return;

      panel.style.height = `${panel.scrollHeight}px`;

      requestAnimationFrame(() => {
        item.classList.remove("is-open");
        button.setAttribute("aria-expanded", "false");
        panel.style.height = "0px";
      });
    }

    setupResizeObserver() {
      if (!("ResizeObserver" in window)) return;

      this.resizeObserver = new ResizeObserver(() => {
        this.updateOpenPanelHeights();
      });

      this.items.forEach((item) => {
        const inner = item.querySelector(".el-faq-accordion__panel-inner");

        if (inner) {
          this.resizeObserver.observe(inner);
        }
      });
    }

    handleResize() {
      this.updateOpenPanelHeights();
    }

    updateOpenPanelHeights() {
      this.items.forEach((item) => {
        if (!item.classList.contains("is-open")) return;

        const panel = item.querySelector("[data-el-faq-panel]");

        if (panel) {
          panel.style.height = `${panel.scrollHeight}px`;
        }
      });
    }
  }

  customElements.define("el-faq-accordion", ElFaqAccordion);
}